import { render, staticRenderFns } from "./SectionBoxLabel.vue?vue&type=template&id=ff27e664&scoped=true&"
import script from "./SectionBoxLabel.vue?vue&type=script&lang=js&"
export * from "./SectionBoxLabel.vue?vue&type=script&lang=js&"
import style0 from "./SectionBoxLabel.vue?vue&type=style&index=0&id=ff27e664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff27e664",
  null
  
)

export default component.exports